module.exports = __webpack_public_path__ + "img/m_mp.e5dffe05.png";